import { render, staticRenderFns } from "./team-compositions.vue?vue&type=template&id=214bb976&scoped=true&"
import script from "./team-compositions.vue?vue&type=script&lang=js&"
export * from "./team-compositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214bb976",
  null
  
)

export default component.exports